import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

const config = {
    apiKey: "AIzaSyBTaCLnbWFQGLZbfy1XFu6a3ai89FyCLBM",
    authDomain: "time-reg.firebaseapp.com",
    databaseURL: "https://time-reg.firebaseio.com",
    projectId: "time-reg",
    storageBucket: "time-reg.appspot.com",
    messagingSenderId: "602137359043"
  };

const firebaseApp = firebase.initializeApp(config)
// const db = firebaseApp.database()

export default firebaseApp